/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import parse from 'html-react-parser';

import { parseJsonProperties } from 'lib/json.service';
import { SocialMediaSharingInterface } from 'components/SocialMediaSharing/declarations';

const SocialMediaSharing: React.FC<SocialMediaSharingInterface> = ({
  tag,
  dataProps,
  replacementValues,
}) => {
  const anchorValue = replacementValues?.anchor;
  useEffect(() => {
    if (!anchorValue) {
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    window.__sharethis__?.initialize();
  }, [anchorValue]);

  const dataVariables = parseJsonProperties(dataProps, replacementValues);
  const element = tag ? parse(tag) : null;

  // @ts-ignore
  const elementProps = element?.props;

  if (elementProps) {
    const allProps = { ...elementProps, ...dataVariables };

    return <div {...allProps} />;
  }

  return (
    <div
      className="sharethis-inline-share-buttons"
      {...dataVariables}
    />
  );
};

export default SocialMediaSharing;
